import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDesignation, IDesignationState } from "./designationModel";
import {
  ActiveInactiveDesignation,
  createDesignation,
  deleteDesignation,
  getAllActiveDesignation,
  getAllDesignation,
  getDesignationByID,
  updateDesignation,
} from "./services/designation.services";

const initialState: IDesignationState = {
  loading: false,
  formloading: false,
  error: "",
  DesignationID: null,
  DesignationList: [],
  DesignationDetail: {
    Title: "",
    Description: "",
    Position: "",
    IsActive: 1,
  },
};

const designationSlice = createSlice({
  name: "designation",
  initialState,
  reducers: {
    clearDesignationDetails: (state) => {
      state.DesignationDetail = initialState.DesignationDetail;
    },
    setDesignationID: (state, action) => {
      state.DesignationID = action.payload;
    },
    clearDesignationID: (state) => {
      state.DesignationID = initialState.DesignationID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllDesignation.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllDesignation.fulfilled,
      (state, action: PayloadAction<IDesignation[]>) => {
        state.loading = false;
        state.DesignationList = action.payload || [];
      }
    );
    builder.addCase(getAllDesignation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.DesignationList = [];
    });
    builder.addCase(createDesignation.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(createDesignation.fulfilled, (state) => {
      state.formloading = false;
    });
    builder.addCase(createDesignation.rejected, (state, action) => {
      state.formloading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateDesignation.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(updateDesignation.fulfilled, (state) => {
      state.formloading = false;
    });
    builder.addCase(updateDesignation.rejected, (state, action) => {
      state.formloading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteDesignation.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteDesignation.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteDesignation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getDesignationByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getDesignationByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.DesignationDetail = action.payload;
    });
    builder.addCase(getDesignationByID.rejected, (state, action) => {
      state.loading = false;
      state.DesignationDetail = initialState.DesignationDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveDesignation.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveDesignation.fulfilled,
      (state, action: PayloadAction<IDesignation[]>) => {
        state.loading = false;
        state.DesignationList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveDesignation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.DesignationList = [];
    });
    builder.addCase(ActiveInactiveDesignation.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveDesignation.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveDesignation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearDesignationDetails, clearDesignationID, setDesignationID } =
  designationSlice.actions;
export default designationSlice.reducer;
